
var confettiButton = $('.btn');
confettiButton.each(function( index ) {

    $(this).click(function() {
        buttonPosition = $(this)[0].getBoundingClientRect();
        buttonTopPosition = (buttonPosition.y + $(this).outerHeight()) / $(window).height();
        buttonLeftPosition = (buttonPosition.x + $(this).outerWidth() / 2) / $(window).width();

        confetti({
            colors: ['#C9AC68'],
            particleCount: 30,
            spread: 45,
            decay: 0.9,
            startVelocity: 18,
            drift: 0,
            gravity: 0.7,
            angle: 90,
            scalar: 0.6,
            ticks: 150,
            origin: { 
                y: buttonTopPosition,
                x: buttonLeftPosition
            },
            resize: true
        });
    });
});

